import { createContext } from 'react';

import { Context } from '../../../types';
import { EmailSettings } from '../types';
import api from '../api';
import { getContextDefaultValues } from '../../providersDataManager';

export default createContext<Context<EmailSettings>>(getContextDefaultValues(api));
